import React, { useState } from 'react';
import { Grid2, TextField, Button, Box, Typography, InputAdornment } from '@mui/material';
import { ContentCopy } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import useNotify from '../../../hooks/useNotify';

function ActiviterForm({ values, setFieldValue }) {
    const { t } = useTranslation();
    const { notifyError, notifySuccess } = useNotify();
    const [copyingField, setCopyingField] = useState(null);

    const copyToClipboard = async (text, fieldName) => {
        if (!text) return;
        setCopyingField(fieldName);
        try {
            await navigator.clipboard.writeText(text);
            notifySuccess(t('common.copiedToClipboard'));
        } catch (err) {
            notifyError(err);
        } finally {
            setCopyingField(null);
        }
    };

    const isEnabled = values.enabled;

    return (
        <>
            <Grid2 size={{ xs: 12 }}>
                <TextField
                    fullWidth
                    label={t('integrations.activiter.widgetUrl')}
                    value={values.settings?.widgetUrl || ''}
                    onChange={(ev) =>
                        setFieldValue('settings', {
                            ...values.settings,
                            widgetUrl: ev.target.value,
                        })
                    }
                    placeholder="https://widget.activiter.com/..."
                    InputProps={{
                        endAdornment:
                            isEnabled && values.settings?.widgetUrl ? (
                                <InputAdornment position="end">
                                    <Button
                                        size="small"
                                        variant="text"
                                        onClick={() =>
                                            copyToClipboard(values.settings.widgetUrl, 'widgetUrl')
                                        }
                                        disabled={copyingField === 'widgetUrl'}
                                    >
                                        <ContentCopy fontSize="small" />
                                    </Button>
                                </InputAdornment>
                            ) : null,
                    }}
                />
            </Grid2>
            <Grid2 size={{ xs: 12 }}>
                <TextField
                    fullWidth
                    label={t('integrations.activiter.apiUrl')}
                    value={values.settings?.apiUrl || ''}
                    onChange={(ev) =>
                        setFieldValue('settings', {
                            ...values.settings,
                            apiUrl: ev.target.value,
                        })
                    }
                    placeholder="https://api.activiter.com/..."
                    InputProps={{
                        endAdornment:
                            isEnabled && values.settings?.apiUrl ? (
                                <InputAdornment position="end">
                                    <Button
                                        size="small"
                                        variant="text"
                                        onClick={() =>
                                            copyToClipboard(values.settings.apiUrl, 'apiUrl')
                                        }
                                        disabled={copyingField === 'apiUrl'}
                                    >
                                        <ContentCopy fontSize="small" />
                                    </Button>
                                </InputAdornment>
                            ) : null,
                    }}
                />
            </Grid2>
            <Grid2 size={{ xs: 12 }}>
                <TextField
                    fullWidth
                    label={t('integrations.activiter.apiKey')}
                    value={values.settings?.apiKey || ''}
                    InputProps={{
                        readOnly: true,
                        endAdornment: values.settings?.apiKey ? (
                            <InputAdornment position="end">
                                <Button
                                    size="small"
                                    variant="text"
                                    onClick={() =>
                                        copyToClipboard(values.settings.apiKey, 'apiKey')
                                    }
                                    disabled={copyingField === 'apiKey'}
                                >
                                    <ContentCopy fontSize="small" />
                                </Button>
                            </InputAdornment>
                        ) : null,
                    }}
                    placeholder={t('integrations.activiter.enableToGenerate')}
                />
            </Grid2>
            <Grid2 size={{ xs: 12 }} sx={{ mt: 2 }}>
                <Typography variant="body2" color="text.secondary">
                    {t('integrations.activiter.description')}
                </Typography>
            </Grid2>
        </>
    );
}

export default ActiviterForm;
